<template>
  <div>
    <v-card>
      <div class="pa-6">
        <div class="d-flex justify-end align-center pb-6">
          <ExportAssign :query="query" @refresh="refresh" />
          <v-spacer></v-spacer>
        </div>
        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="students"
            :items-per-page="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :server-items-length="pagination.totalItems"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            :footer-props="{ 'items-per-page-text': 'Số học sinh mỗi trang' }"
            :height="400"
            v-bind="this.$attrs"
            fixed-header
            @pagination="updatePagination"
          >
            <template v-slot:[`footer.page-text`]="items">
              Phòng thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} phòng
            </template>
            <template v-slot:[`item.room`]="{ item }">
              {{ item.room.name || '-' }}
            </template>
            <template v-slot:[`item.subject`]="{ item }">
              {{ item.subject.name || '-' }}
            </template>
            <template v-slot:[`item.teacher`]="{ item }">
              {{ item.teacher | getMonitorName }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as XLSX from 'xlsx'
import { ExamMark } from '../../plugins/api'
import ExportAssign from './ExportAssign.vue'

const originHeaders = [
  {
    text: 'Phòng thi',
    value: 'room',
    align: 'left',
    sortable: false
  },
  {
    text: 'Môn thi',
    value: 'subject',
    align: 'left',
    sortable: false
  },
  {
    text: 'Chấm thi',
    value: 'teacher',
    align: 'left',
    sortable: false
  }
]

export default {
  props: {
    query: Object,
    subjects: Array,
    rooms: Array,
    type: String,
    grade: String
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      roomDialog: false,
      confirmDialog: false,
      dateDialog: false,
      showColumnSelector: false,
      singleDateDialog: false,
      selectedItems: [],
      selected: [],
      students: [],
      item: {},
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      },
      json_fields: {
        'Họ tên': 'name',
        'Mã HS': 'code_short',
        SBD: 'examCode',
        Môn: 'subject',
        'Mã phách': 'testCode',
        'Phòng thi': 'room'
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('roomSubject', ['fetchRoomSubjects', 'countRoomSubjects']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countRoomSubjects(this.query)
        this.students = await this.fetchRoomSubjects({
          _start: start,
          _limit: limit,
          ...this.query,
          _sort: 'index:asc'
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    async exportDataToExcel() {
      this.$loading.active = true
      const data = await ExamMark.getMarksData({ exam: this.query.exam })

      const formattedData = this.mapFields(data, this.json_fields)

      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Marks')

      XLSX.writeFile(workbook, `ma_phach.xlsx`)
      this.$loading.active = false
    },
    mapFields(data, fieldMap) {
      return data.map(item => {
        const newItem = {}
        for (const [key, value] of Object.entries(fieldMap)) {
          newItem[key] = item[value]
        }
        return newItem
      })
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    },
    formatArray(array) {
      const names = array.map(item => item.name)
      return names.join(', ')
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    date() {
      this.selectedItems = this.selected.map(item => item.id)
      this.dateDialog = true
    },

    closeDate() {
      this.dateDialog = false
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getMonitorName: item => {
      if (item) {
        return item.name
      } else {
        return '-'
      }
    }
  },
  components: {
    ExportAssign
  }
}
</script>
